/**
 * Placeholder screens for FEEDS / PANEL / INTEL / ARCHIVE modes.
 * Real implementations ship in turns 2–3. These keep the nav IA whole
 * so the top-bar SHOW/FEEDS/PANEL/INTEL/ARCHIVE buttons all route somewhere.
 */
import React from 'react';
import ShowHeader from './ShowHeader';

const COPY = {
  feeds: {
    title: 'FEEDS',
    note: 'Dedicated feed board: breaking / trending / top stories / verified evidence / topic candidates / region feeds / transcript digest. Wires to the Wire news-desk backend in turn 2.',
  },
  panel: {
    title: 'PANEL',
    note: 'Audience-facing panel focus view with single-speaker mode, split comparison, and challenge view. Ships in turn 3 once the crew verification loop is wired.',
  },
  intel: {
    title: 'INTEL',
    note: 'Backstage intelligence board: source health, evidence packets, verification holds, script traces, and scoring snapshots. Ships in turn 3.',
  },
  archive: {
    title: 'ARCHIVE',
    note: 'Prior episodes, transcripts, outcome verification, clips, script history and panel performance. Ships in turn 3 once stenographer persistence lands.',
  },
};

export default function StudioPlaceholder({ mode, onNavigate }) {
  const copy = COPY[mode] || COPY.feeds;
  return (
    <div className="studio-shell" data-testid={`studio-placeholder-${mode}`}>
      <ShowHeader mode={mode} onNavigate={onNavigate} status="PREP" episode={null} sensorSummary={null} nextSpeaker="host" />
      <div style={{ gridColumn: '1 / -1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="studio-placeholder">
          <div className="code">{copy.title}</div>
          <div className="note">{copy.note}</div>
          <div style={{ marginTop: 18, fontSize: 11, color: 'var(--studio-text-3)', letterSpacing: '0.18em', textTransform: 'uppercase' }}>
            coming next turn · all backend hooks already wired
          </div>
        </div>
      </div>
      <div className="studio-bottom" />
    </div>
  );
}
